import api from "@modules/api/api";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import purchaseQueryKeys from "../../purchaseQueryKeys";
import { ExtendedWarrantyRatesResponse } from "../types/ExtendedWarrantyRates";
import { getCoveragesError } from "../helpers/getCoveragesError";

type ExtendedWarrantyRatesRequestError = {
  success: false;
  message: string;
};

const getExtendedWarrantyAllRates = async (dealId: string | undefined) => {
  const response = await api.get<
    ExtendedWarrantyRatesResponse | ExtendedWarrantyRatesRequestError
  >(`api/purchases/${dealId}/ext-warranty-all-rates`);

  // Handling expected errors based on response content
  if (response.success === false) {
    throw new Error(response.message);
  }

  return response;
};

export default function useExtendedWarrantyAllRates(
  dealId: string | undefined
) {
  const queryResult = useQuery({
    queryKey: purchaseQueryKeys.extendedWarrantyAllRates(),
    queryFn: () => getExtendedWarrantyAllRates(dealId),
    placeholderData: keepPreviousData,
    enabled: !!dealId,
  });

  return {
    ...queryResult,
    coverageError: queryResult.isError
      ? getCoveragesError(queryResult.error)
      : null,
  };
}
